"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.types25 = void 0;
const types_23_1 = require("./types_23");
exports.types25 = Object.assign(Object.assign({}, types_23_1.types23), { DidAuthorizedCallOperation: {
        did: "DidIdentifierOf",
        txCounter: "u64",
        call: "DidCallableOf",
        submitter: "AccountId",
    } });
